/*
 *
 * WidgetResponseRateReport reducer
 *
 */

import { fromJS } from "immutable"
import {
  GET_DATA_DIVISIONS_RATE_WATCHER,
  GET_DATA_DIVISIONS_RATE_SUCCESS,
  GET_DATA_DIVISIONS_RATE_FAILED,
} from "./constants"

export const initialState = fromJS({
  isLoading: true,
  divisionsRate: null,
})

function widgetResponseRateReportReducer(state = initialState, action) {
  switch (action.type) {
    case GET_DATA_DIVISIONS_RATE_WATCHER:
      return state.set("isLoading", true).set("divisionsRate", null)

    case GET_DATA_DIVISIONS_RATE_SUCCESS:
      return state.set("isLoading", false).set("divisionsRate", action.payload)

    case GET_DATA_DIVISIONS_RATE_FAILED:
      return state.set("isLoading", false).set("divisionsRate", null)

    default:
      return state
  }
}

export default widgetResponseRateReportReducer
